'use client';

import React from 'react';
import { FESTIVE_PLANS_ANCHOR_ID } from '../festiveOffer';
import { FestiveStepRows } from './FestiveStepRows';
import { FestivePlanPanelsGeist } from './FestivePlanPanelsV2';
import { FestiveV2Callback } from './FestiveV2Callback';
import { geistMono } from 'utils/fonts';
import styles from './festivePanels.module.css';

/** V3 body: step rows, Geist plan panels, and the closing callback. */
export const FestivePanelsLayout: React.FC = () => {
  return (
    <div
      className={`${styles.panels} ${geistMono.variable}`}
      data-density="tight"
      data-type="geist"
    >
      <FestiveStepRows type="geist" showCallback={false} />
      <div className={styles.planPanels} id={FESTIVE_PLANS_ANCHOR_ID}>
        <FestivePlanPanelsGeist />
      </div>
      <FestiveV2Callback />
    </div>
  );
};
